import '../../scss/security.scss';

import {Router} from '../common/router';
const $ = require('jquery');
const spinner = document.createElement('span');
spinner.classList.add('spinner-border', 'spinner-border-sm', 'mx-3');
let isDirty = false;
let isPasswordCorrect = null;
let submitBtn;
let editBtn;
let elements;

document.addEventListener('DOMContentLoaded', () => {
    let readLink = $('a.terms-conditions').detach();
    $('label[for="cgu"]').after(readLink);
    if (document.querySelector('.form-account') !== null) {
        document.querySelector('.edit-details').addEventListener('click', toggleEditAccount);
        document.querySelector('.edit-details-mobile').addEventListener('click', toggleEditAccount);
        document.querySelector('.details-mobile').addEventListener('click', toggleEditAccount);
        document.querySelector('form').addEventListener('submit', submitForm);

        if (window.location.href.indexOf('#edit') > -1) {
            document.querySelector('.edit-details').click();
        }

        initDelete();
    }
});

/**
 * adds event listener to delete-account button to trigger modal
 */
const initDelete = () => {
    const btns = Array.from(document.querySelectorAll('.delete-account'));
    btns.map(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            const modal = document.querySelector('.delete-modal');
            modal.classList.add('enable');

            modal.querySelector('.cancel').addEventListener('click', () => {
                modal.classList.remove('enable');
            });
        });
    })
};

/**
 * Displays all form fields and hide original values
 */
const toggleEditAccount = (e) => {
    elements = Array.from(document.querySelectorAll('.current, .edit'));
    elements.map(elem => {
        elem.classList.toggle('enable');
    });
    document.querySelector('.checkbox-container').classList.toggle('enable');
    document.querySelector('.account-row .edit.password button').addEventListener('click', handlePassword);
    if (window.screen.width > 992) {
        submitBtn = document.querySelector('.btn-submit');
        editBtn = document.querySelector('.edit-details');
        e.target.classList.toggle('enable');
    } else {
        submitBtn = document.querySelector('.btn-submit-mobile');
        editBtn = document.querySelector('.edit-details-mobile');
        editBtn.classList.toggle('enable');
    }
    submitBtn.classList.toggle('enable');
    promptOnDirtyForm();
};

/**
 * Cancels submit if is submitting or password input is dirty and is not matching
 */
const submitForm = (e) => {
    e.preventDefault();
    if (submitBtn.classList.contains('submitting')) {
        return;
    }
    if (isPasswordCorrect === false) {
        document.querySelector('.password-form .error').innerText = Translator.transChoice('account.password_error');
        return;
    }
    const lang = document.documentElement.lang;
    submitBtn.classList.add('submitting');
    submitBtn.appendChild(spinner);
    $.ajax({
        url: Router.generate(
            'ajax_account_update.' + lang
        ),
        data: $(e.target).serialize(),
        method: 'POST',
        global: false,
        success: function (data) {
            if (data['updated']) {
                submitBtn.querySelector('.button-text').innerText = Translator.transChoice('account.updates_saved');
                submitBtn.classList.add('updated');
                updateValues();

                if (window.location.href.indexOf('#edit') > -1) {
                    const referrer = document.referrer;
                    if(referrer.indexOf(window.location.host) > -1) {
                        setTimeout(() => window.location.href = referrer, 500);
                    }

                    return;

                }

                setTimeout(reset, 1000);
            } else {
                triggerErrorUpdate(data['message'] ?? undefined);
            }
        },
        error: function () {
            triggerErrorUpdate();
        },
    }).always(function () {
        submitBtn.classList.remove('submitting');
        submitBtn.removeChild(spinner);
        document.querySelector('.password-form .error').innerText = '';
        window.removeEventListener('beforeunload', triggerPrompt);

        setTimeout(() => location.reload(), 1500);
    })
};

/**
 * display error message
 */
const triggerErrorUpdate = (message) => {
    submitBtn.classList.add('error');
    submitBtn.querySelector('.button-text').innerText = message ?? Translator.transChoice('account.update_error');
};

/**
 * if form is dirty will alert user that changes will be lost
 */
const promptOnDirtyForm = () => {
    document.querySelector('form').addEventListener('input', () => {
        isDirty = true;
    }, {once: true});
    window.addEventListener('beforeunload', triggerPrompt);
};

/**
 * prevents unloading of page with a prompt box
 */
const triggerPrompt = (e) => {
    if (isDirty) {
        e.preventDefault();
        e.returnValue = '';
    }
};

/**
 * adds icons in input, checks validation and sets that passwords match
 */
const handlePassword = (e) => {
    const passwordForm = document.querySelector('.password-form');
    const title = Translator.transChoice('account.password_info');
    const errorIcon = `<i class='fal fa-times-circle' title='${title}'></i>`;
    const formGroups = Array.from(passwordForm.querySelectorAll('.form-group'));
    e.target.parentElement.classList.toggle('enable');
    passwordForm.classList.toggle('enable');
    formGroups.map((div, key) => {
        div.insertAdjacentHTML('beforeend', errorIcon);
        div.querySelector('input').addEventListener('input', () => {
            const firstIcon = formGroups[0].querySelector('i').classList;
            const secondIcon = formGroups[1].querySelector('i').classList;
            const firstInput = formGroups[0].querySelector('input').value;
            const secondInput = formGroups[1].querySelector('input').value;
            if (key === 0) {
                if (firstInput.length >= 4) {
                    firstIcon.replace('fa-times-circle', 'fa-check-circle');
                } else {
                    firstIcon.replace('fa-check-circle', 'fa-times-circle');
                }
                if (firstInput !== secondInput) {
                    secondIcon.replace('fa-check-circle', 'fa-times-circle');
                    isPasswordCorrect = false;
                } else {
                    isPasswordCorrect = true;
                }
            }
            if (key === 1) {
                if (secondInput.length >= 4 && firstInput === secondInput) {
                    secondIcon.replace('fa-times-circle', 'fa-check-circle');
                    isPasswordCorrect = true;
                } else {
                    secondIcon.replace('fa-check-circle', 'fa-times-circle');
                    isPasswordCorrect = false;
                }
            }
            if (firstInput.length === 0 && secondInput.length === 0) {
                isPasswordCorrect = null;
            }
        })
    })
};

/**
 * Updates original displays with new updated values
 */
const updateValues = () => {
    const genderRowRadios = Array.from(document.querySelectorAll('.account-row.gender input'));
    const firstNameRow = document.querySelector('.account-row.firstname');
    const lastNameRow = document.querySelector('.account-row.lastname');
    const countryRow = document.querySelector('.account-row.country');
    const jobRow = document.querySelector('.account-row.job');
    genderRowRadios.map(radio => {
        if (radio.checked) {
            document.querySelector('.account-row.gender .current').innerText = radio.value;
        }
    });
    firstNameRow.querySelector('.current').innerText = firstNameRow.querySelector('.edit input').value;
    lastNameRow.querySelector('.current').innerText = lastNameRow.querySelector('.edit input').value;
    countryRow.querySelector('.current').innerText = countryRow.querySelector('.edit select').selectedOptions[0].text;
    jobRow.querySelector('.current').innerText = jobRow.querySelector('.edit select').selectedOptions[0].text;
};

/**
 *  Resets display to it's original form and empty password inputs
 */
const reset = () => {
    editBtn.classList.toggle('enable');
    submitBtn.classList.remove('enable', 'updated', 'error');
    submitBtn.querySelector('.button-text').innerText = Translator.trans('account.save_updates');
    elements.map(element => {
        element.classList.toggle('enable');
    });
    document.querySelector('.checkbox-container').classList.remove('enable');
    document.querySelector('.password-form').classList.remove('enable');
    document.querySelector('.edit.password').classList.remove('enable');
    const passwordInputs = Array.from(document.querySelectorAll('.password-form input'));
    passwordInputs.map(input => {
        input.value = '';
        if (input.nextElementSibling !== null) {
            input.nextElementSibling.remove();
        }
    });
};




